import {initWebComponent} from "@/helpers/web-component-helper";
import {hideLayerInfoForm, initHideButton} from "@/helpers/layer/info/layer-info-helper";
import {hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {getUserSession} from "@/helpers/user-session-helper";


export class LayerMenuSwitcherButtonActiveComponent extends HTMLElement{
    constructor(){
        super();

        const checked = this.getAttribute('data-checked')

        let isChecked = ''
        if(checked === "1") {
            isChecked = 'checked="checked"'
        }

        const template = document.createElement('template');
        template.innerHTML = `
<span class="fa fa-book"></span> <h2 class="d-inline">Catalogus</h2> <span class="badge badge-outline-secondary" id="spnTotalLayers"></span>
  <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu d-block d-md-none">
                <span class="fa fa-times"></span>
             </button>
<label class="switcher float-right">
    <span class="switcher-label w-100" style="margin-top:1px">
        <i class="fa fa-layer-group"></i> Actieve lagen 
    </span>
    <input type="checkbox" ${isChecked} class="switcher-input">
    <span class="switcher-indicator">
      <span class="switcher-yes">
        <span class="fa fa-draw-polygon"></span>
      </span>
      <span class="switcher-no">
        <span class="fa fa-times"></span>
      </span>
    </span>
  </label>
`;

        initWebComponent(this, template)

        const button = this.querySelector('button')
        this.addEventListener('change', (e) => {
            // this.classList.add('d-none')

            const checked = e.target.checked

            if(checked) {
                hideElementsBySelector('layer-menu-overview')
                showElementsBySelector('layer-menu-switcher')
                showElementsBySelector('layer-menu-active')
                hideElementsBySelector('layer-menu-search')
                if(getUserSession()) {
                    showElementsBySelector('#divActiveSession')
                }
            } else {
                showElementsBySelector('layer-menu-overview')
                hideElementsBySelector('layer-menu-switcher')
                hideElementsBySelector('layer-menu-active')
                showElementsBySelector('layer-menu-search')
                hideElementsBySelector('#divActiveSession')
            }
        });

        initHideButton()
    }
}
